<p-accordion [value]="null" class="options-sidebar">
  <p-accordion-panel value="0">
    <div
      class="rounded-4 overflow-hidden border selected-product-panel"
      [class.has-validation-errors]="hasValidationErrors()"
    >
      <p-accordion-header>
        <div class="d-flex flex-fill align-items-center gap-2">
          <div class="d-flex flex-column gap-1">
            <div class="d-flex align-items-center w-100 gap-2 flex-wrap">
              <h6 class="m-0">{{ product().code }}</h6>
              <!-- <span class="badge border fw-500 text-body-secondary text-dark">{{ product().type }}</span> -->
              @if (hasValidationErrors()) {
                <span class="badge bg-danger-subtle fw-400 fw-500 text-danger"
                  >{{ validationErrorCount() }} missing fields</span
                >
              }
              <span class="fw-500 text-success text-nowrap">{{
                selectionForm().controls.unitPrice.value | currencyFormat
              }}</span>
            </div>

            <!-- <p class="m-0 text-muted fs-14 fw-500">{{ product().description }}</p> -->
          </div>
          @if (showDeleteIcon()) {
            <i class="bi bi-trash3 fs-14 text-danger me-2 ms-auto lh-1" role="button" (click)="remove()"></i>
          }
        </div>
      </p-accordion-header>
      <p-accordion-content class="d-block">
        <form class="h-100 d-flex flex-column flex-fill overflow-hidden pt-3" [formGroup]="selectionForm()">
          <div class="mb-3">
            <label class="form-label">Location</label>

            <generic-dropdown
              class="w-100"
              placeholder="Select Location"
              [items]="locationOptions.value()"
              [clearable]="true"
              formControlName="locationId"
            />
            @if (!locationOptions.value().length) {
              <p class="text-muted fs-12 mb-0 mt-1">No locations available for this product.</p>
            }
          </div>
          @if (productAttributes().length) {
            <div [formGroup]="attributeValuesGroup" class="d-flex flex-column gap-3 mb-3">
              @for (attribute of productAttributes(); track attribute.subCategoryAttributeId) {
                <div>
                  <label class="form-label">{{ attribute.subCategoryAttributeName }}</label>
                  <generic-dropdown
                    class="w-100"
                    placeholder="Select {{ attribute.subCategoryAttributeName }}"
                    [items]="attributeValueOptions().get(attribute.subCategoryAttributeId) ?? []"
                    [clearable]="true"
                    [allowSearch]="true"
                    [formControlName]="attribute.subCategoryAttributeId"
                  />
                  @if (!attributeValueOptions().get(attribute.subCategoryAttributeId)?.length) {
                    <p class="text-muted fs-12 mb-0 mt-1">No values available for this attribute.</p>
                  }
                </div>
              }
            </div>
          } @else if (!productAttributesResource.isLoading()) {
            <p class="text-muted fs-12 mb-3">No attributes available for this product.</p>
          }

          <div class="d-flex align-items-center justify-content-between mb-3">
            <currency-input-field
              class="w-100"
              [label]="'Unit Price'"
              [placeholder]="'Enter'"
              formControlName="unitPrice"
              [min]="null"
              [errormessage]="'Unit Price is required.'"
              [customClass]="'form-control'"
            ></currency-input-field>
          </div>

          <div class="d-flex align-items-center justify-content-between mb-3">
            <label class="form-label m-0">Unit of Measurement</label>
            <span>{{ product().uom }}</span>
          </div>
          <div class="mb-3">
            <label class="form-label">Sales description: </label>
            <p class="m-0 fs-14">{{ product().salesDescription }}</p>
          </div>
          <div class="mb-3">
            <label class="form-label">Option Notes</label>
            <textarea
              pTextarea
              rows="4"
              class="form-control"
              placeholder="Add Notes"
              formControlName="notes"
            ></textarea>
          </div>
          <!-- <button class="btn btn-primary w-100 justify-content-center btn-h35 test" type="button">Submit</button> -->
        </form>
      </p-accordion-content>
    </div>
  </p-accordion-panel>
</p-accordion>
